import React from "react";

const Strategy = () => {
  return <></>;
};

export default Strategy;
